<div class="vds-toast-content">
    @switch (type()) {
        @case ("success") {
            <vds-icon name="checkmark-filled" class="vds-toast__icon--success" />
        }
        @case ("warning") {
            <vds-icon name="warning-filled" class="vds-toast__icon--warning" />
        }
        @case ("error") {
            <vds-icon name="error-filled" class="vds-toast__icon--error" />
        }
        @case ("loading") {
            <vds-progress-spinner />
        }
        @default {
            <vds-icon name="information-filled" class="vds-toast__icon--info" />
        }
    }

    <span class="vds-toast-message">{{ message() }}</span>
    @if (hasAction()) {
        <button class="vds-toast-button" aria-hidden="true" [attr.aria-label]="actionLabel()" (click)="action()">
            <vds-icon name="close-large" />
        </button>
    }
</div>
